export default __webpack_public_path__ + "static/media/icon-nurse.a69aa790.svg";